import PropTypes from "prop-types";

import { FormCombobox, SectionCard } from "components/BaseForm";

const PresetsSection = ({
  regionOptions,
  campaignStatusPresetOptions,
  revenueStatusPresetOptions,
  revenueRecipientPresetOptions,
}) => (
  <SectionCard title="Presets">
    <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
      <FormCombobox
        name="region_id"
        label="Region"
        clearable
        options={regionOptions}
      />
      <FormCombobox
        name="case_campaign_status_preset"
        label="Case Campaign Status Preset"
        clearable
        options={campaignStatusPresetOptions}
      />
      <FormCombobox
        name="campaign_status_preset"
        label="Campaign Status Preset"
        clearable
        options={campaignStatusPresetOptions}
      />
      <FormCombobox
        name="revenue_status_preset"
        label="Revenue Opportunity Status Preset"
        clearable
        options={revenueStatusPresetOptions}
      />
      <FormCombobox
        name="revenue_recipient_preset"
        label="Revenue Opportunity Recipient Preset"
        clearable
        options={revenueRecipientPresetOptions}
      />
    </div>
  </SectionCard>
);

PresetsSection.propTypes = {
  regionOptions: PropTypes.array.isRequired,
  campaignStatusPresetOptions: PropTypes.array.isRequired,
  revenueStatusPresetOptions: PropTypes.array.isRequired,
  revenueRecipientPresetOptions: PropTypes.array.isRequired,
};

export default PresetsSection;
